<template>
  <el-table-column
    v-bind="$attrs"
    :label="label"
    align="center"
    >
    <template slot-scope="scope">
      <brand-field
        :base="base"
        :row="scope.row"
        >
      </brand-field>
      <item-link
        :base="base"
        basePath=""
        baseField="orders_id"
        baseIDField="orders_id"
        idField="orders_id"
        nameField="orders_id"
        :rowData="scope.row"
        :isAllowList="false"
        displayType="text"
        type="primary"
        class="list-main"
        >
      </item-link>
    </template>
  </el-table-column>
</template>

<script>

import { getLabelText } from '@/utils/i18n'

export default {
  name: 'brand-orders-field',
  props: {
    base: {
      type: String,
      default: ''
    },
    labelText: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  computed: {
    label () {
      return this.labelText || this.getLabelText('payment_brand', 'orders_id')
    }
  },
  methods: {
    getLabelText
  },
  watch: {
  }
}
</script>
